<template src="./project-create.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import { EventBus } from '@/router/bus'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import { hasFormImportantManage } from '@/router/auth'

export default {
  components: {
    ContextPage
  },
  mixins: [validationMixin],
  data () {
    return {
      project: { type: 3, important: false },
      projectTypes: [
        { text: this.$t('projects.types.1'), value: 1 },
        { text: this.$t('projects.types.2'), value: 2 },
        { text: this.$t('projects.types.3'), value: 3 }
      ],
      projectSectors: [
        { text: this.$t('projects.sectors.1'), value: 1 },
        { text: this.$t('projects.sectors.2'), value: 2 },
        { text: this.$t('projects.sectors.3'), value: 3 },
        { text: this.$t('projects.sectors.4'), value: 4 },
        { text: this.$t('projects.sectors.5'), value: 5 },
        { text: this.$t('projects.sectors.6'), value: 6 }
      ],
      projectImportant: [
        { text: this.$t('bool.no'), value: false },
        { text: this.$t('bool.yes'), value: true }
      ],
      dialog: false,
      formValid: true,
      loading: false,
      help: {
        list: Vue.$helpConfig.projectCreate
      }
    }
  },
  computed: {
    codeErrors () {
      return this.getValidationErrorsByName('code')
    },
    projectTypeErrors () {
      return this.getValidationErrorsByName('type')
    },
    projectSectorErrors () {
      return this.getValidationErrorsByName('sector')
    },
    canSetProjectImportant () {
      return hasFormImportantManage()
    }
  },
  methods: {
    validateBeforeProjectSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.openDialog()
    },
    addProject () {
      this.loading = true
      this.dialog = false
      this.project.code = this.project.code.trim().split(' ').join('-')
      this.project.sector = this.projectSectors[0].value

      this.$http.post(Vue.$apiConfig.createProjectPost, this.project).then(
        response => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('projects.createProjectSuccessful'),
            errors: []
          })
          this.loading = false
          this.dialog = false
          this.$router.push('/projects/' + this.project.code)
        },
        error => {
          this.formatErrorResponse(error)
          this.loading = false
        })
    },
    openDialog () {
      if (!this.$refs.form.validate()) {
        this.scrollToForm()
        return
      }
      this.dialog = true
    },
    getValidationErrorsByName (name) {
      if (!this.$v.project[name].$dirty) return []
      return this.getValidationErrors('project').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  validations () {
    const rules = {}

    Object.assign(rules, {
      code: {
        required,
        maxLength: maxLength(20)
      }
    })

    return {
      project: rules
    }
  }
}
</script>
